module.exports = __webpack_public_path__ + "img/gyant_light_grey_ba_detail_rsh1(1).51f660bf.jpg";